import { Component, OnInit, Output, Input, EventEmitter } from '@angular/core';
import { listTransition } from '@app/core/animations/list-animations';
import { Product, Media } from '@app/shared';


// import { State } from './asset-search.component';
enum State {
  list = "list",
  detail = "detail",
}

@Component({
  selector: 'app-product-search',
  templateUrl: './product-search.component.html',
  styleUrls: ['./product-search.component.scss'],
  animations: [ listTransition ]
})


export class ProductSearchComponent implements OnInit {

  @Output() onSearch = new EventEmitter<any>();
  @Output() onCloseClick = new EventEmitter<any>();
  @Input()
  public set products(val:Product[]){
    this._products = val;
  }
  public get products():Product[]{
    return this._products;
  }
  state = State;
  view_state = State.list;
  product:Product;
  media:Media;

  searchStr:string = "";
  private _products:Product[];

  constructor() { }

  ngOnInit() {
  }

  // public getHeroMedia(val:Product):string{
  //   const media = (val as Product).heroMedia;
  //
  //   return media?media.thumbUrl:'';
  // }

  search():void{

    let oa = {product:null,keyword:this.searchStr,includeAssets:true};

    if(this.searchStr.length)
      this.onSearch.emit(oa);
    else
      this.products = [];
  }

  back():void{
    this.view_state = State.list;
  }
  closeClick():void{
    this.onCloseClick.emit();
  }

  onMediaClick(product:Product,media:Media):void{
    //this.view_state = State.detail;
    this.product = product;
    this.media = media;
  }

}



// WEBPACK FOOTER //
// /var/lib/jenkins/workspace/pmclient-uat/src/app/shared/components/offer-editor/product-search/product-search.component.ts